import { ENDPOINTS } from "../../utils/endPoints";
import { UPDATE_AUTH, EMPTY_AUTH } from "../../store/actionTypes";
import { toast } from "react-hot-toast";
import {
  GET_API_CALL,
  POST_API_CALL,
  PUT_API_CALL,
  PUT_API_CALL_CHANGE_PASSWORD,
} from "../../utils/services";

/**
 * @description all about auth actions
 * @param {loginFoamData} data
 * @param { function } callback
 * @returns update Auth reducer
 */

export const login = (data, callback) => {
  return (dispatch) => {
    const toastId = toast.loading("Processing Login");
    POST_API_CALL(ENDPOINTS.AUTH.LOGIN, data, (response) => {
      console.log("Response ", response);
      if (response.isSuccess) {
        toast.success(response?.data?.message);
        let dataToSave = response?.data;
        dispatch({
          type: UPDATE_AUTH,
          payload: {
            ...dataToSave,
            ...{ isSessionValid: null },
            adminDetails: { ...dataToSave },
          },
        });
      }
      toast.dismiss(toastId);
      callback(response);
    });
  };
};

export const logoutAction = (callback) => {
  return (dispatch) => {
    POST_API_CALL(ENDPOINTS.AUTH.LOGOUT, {}, (response) => {
      console.log("Logout Response :", response);
      if (response.isSuccess) {
        toast.success(response?.data?.message);
        dispatch({
          type: EMPTY_AUTH,
          payload: {},
        });
      }
      callback(response);
    });
  };
};

export const forgotPassword = (data, callback) => {
  return () => {
    POST_API_CALL(ENDPOINTS.AUTH.FORGOT_PASSWORD, data, (response) => {
      console.log("Forgot Password Response :", response);
      if (response.isSuccess) {
        toast.success(response.data?.message);
      }
      callback(response);
    });
  };
};

export const verifyOtp = (data) => {
  return () => {
    POST_API_CALL(ENDPOINTS.AUTH.VERIFY_OTP, data, (response) => {
      console.log("Vefify OTP Response :", response);
      if (response.isSuccess) {
        toast.success(response.data?.message);
      }
    });
  };
};

export const resendOtp = (data) => {
  const toastId = toast.loading("Sending OTP");
  return () => {
    POST_API_CALL(ENDPOINTS.AUTH.RESEND_OTP, data, (response) => {
      console.log("Resend OTP Response :", response);
      if (response.isSuccess) {
        toast.success(response.data?.message);
      }
      toast.dismiss(toastId);
    });
  };
};

export const getProfile = (callback) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_AUTH,
      payload: { ...{ isLoading: true } },
    });
    GET_API_CALL(ENDPOINTS.AUTH.PROFILE, "", (response) => {
      console.log("Profile Response :", response);
      if (response.isSuccess) {
        callback(response.data);
        dispatch({
          type: UPDATE_AUTH,
          // payload:{...response.data.data},
          payload: { adminDetails: { ...response.data.data } },
        });
      } else {
        callback(null);
      }
      dispatch({
        type: UPDATE_AUTH,
        payload: { ...{ isLoading: false } },
      });
    });
  };
};

export const changePasswordAction = (data, callback) => {
  return () => {
    PUT_API_CALL(ENDPOINTS.AUTH.CHANGE_PASSWORD, data, (response) => {
      console.log("Change Password Response :", response);
      if (response.isSuccess) {
        toast.success(response?.data?.message);
        callback(response);
      } else callback({});
    });
  };
};

export const editProfile = (data, callback) => {
  const toastId = toast.loading("SAVING DETAILS");
  return () => {
    PUT_API_CALL(ENDPOINTS.AUTH.EDIT_PROFILE, data, (response) => {
      console.log("Edit Profile Response :", response);
      if (response.isSuccess) {
        toast.success(response.data.message);
        callback();
      }
      toast.dismiss(toastId);
    });
  };
};
